angular
  .module('UserExamMain', [
    'angularSoundManager',

    'UserExamControllers',
    'UserTrainingControllers',
    'UserBuildUpMain'
  ])

  //config for /supports
  .config([
    '$routeProvider',
    function($routeProvider) {
      $routeProvider

        // exam
        .when('/exam', {
          templateUrl: '/ng1/www/modules/user/practice/exam/html/home.html',
          controller: 'ExamHomeCtrl'
        })
        // exam
        .when('/examen', {
          templateUrl: '/ng1/www/modules/user/practice/exam/html/home.html',
          controller: 'ExamHomeCtrl'
        })
        .when('/exam/on', {
          templateUrl: '/ng1/www/modules/user/practice/exam/html/on.html',
          controller: 'ExamOnCtrl'
        })
        .when('/examen/on', {
          templateUrl: '/ng1/www/modules/user/practice/exam/html/on.html',
          controller: 'ExamOnCtrl'
        })
        .when('/result/:id', {
          templateUrl: '/ng1/www/modules/user/practice/exam/html/historic.html',
          controller: 'ExamHistoricCtrl'
        })
        .when('/resultat/:id', {
          templateUrl: '/ng1/www/modules/user/practice/exam/html/historic.html',
          controller: 'ExamHistoricCtrl'
        })
        //training
        .when('/training', {
          templateUrl: '/ng1/www/modules/user/practice/training/html/home.html',
          controller: 'TrainingHomeCtrl'
        })
        .when('/entrainement', {
          templateUrl: '/ng1/www/modules/user/practice/training/html/home.html',
          controller: 'TrainingHomeCtrl'
        })
        .when('/training/on', {
          templateUrl: '/ng1/www/modules/user/practice/training/html/on.html',
          controller: 'TrainingOnCtrl'
          //reloadOnSearch: false
        })
        .when('/entrainement/on', {
          templateUrl: '/ng1/www/modules/user/practice/training/html/on.html',
          controller: 'TrainingOnCtrl'
          //reloadOnSearch: false
        });
    }
  ])

  .directive('cfReportError', [
    '$http',
    function($http) {
      return {
        restrict: 'E',
        template: `<br><div ng-click="report()" class="report-error"><small><em ng-if="!sended">{{'training_detail.signal_error' | translate}}</em><em ng-if="!!sended">{{'training_detail.thanks_for_help' | translate}}</em></small></div><br><br>`,
        controller: [
          '$scope',
          'api',
          '$translate',
          function($scope, api, $translate) {
            $scope.sended = false;
            $scope.report = function() {
              if ($scope.sended) {
                return;
              }

              let tr = $translate.instant(['training_detail.ask_error']);
              let errorInput = window.prompt(tr['training_detail.ask_error']);

              if (errorInput) {
                $scope.sended = true;
                api
                  .insertFeedbacks(
                    $scope.support.id,
                    $scope.support,
                    errorInput
                  )
                  .then(response => {
                    console.log(response.status);
                  });
              }
            };
          }
        ]
      };
    }
  ]);
